import type { ApplicationConfiguration } from '@/common/overmind/namespaces/arcgis/config/config.types';
import { useAppState } from '@/overmind';

type FeatureToggles = {
  isEsriWebmapEnabled: () => boolean;
  isShowingGridElementTitleEnabled: () => boolean;
  isShowingApplicationVersionEnabled: () => boolean;
  isContainmentExecutionTimeCalculatedEnabled: () => boolean;
  isNewAuthVersionEnabled: () => boolean;
  isProtectiveDevicesEnabled: () => boolean;
  isWebmapBackgroundMapEnabled: () => boolean;
  isNewPropertiesForAcLineSegmentEnabled: () => boolean;
  isArcGisJsSDKWebMapForBrowsingCalculationResultsEnabled: () => boolean;
  shouldUseInitiatingObjectHighlighting: () => boolean;
};

const useFeatureToggles: () => FeatureToggles = () => {
  const appConfig = useAppState().config;
  const isEsriLeafletEnabled =
    useAppState().featureToggles?.isEsriWebMapEnabled;
  const isShowingGridDetailsEnabled =
    useAppState().featureToggles?.isShowingGridElementTitleEnabled;
  const isShowingApplicationVersionEnabled =
    useAppState().featureToggles?.isShowingApplicationVersionEnabled;
  const isContainmentExecutionTimeCalculatedEnabled =
    useAppState().featureToggles?.isContainmentExecutionTimeCalculatedEnabled;
  const isNewAuthVersionEnabled =
    useAppState().featureToggles?.isNewAuthVersionEnabled;

  const isProtectiveDevicesEnabled =
    useAppState().featureToggles?.isProtectiveDevicesEnabled;

  const isWebmapBackgroundMapEnabled =
    useAppState().featureToggles?.isWebmapBackgroundMapEnabled;

  const isNewPropertiesForAcLineSegmentEnabled =
    useAppState().featureToggles?.isNewPropertiesForAcLineSegmentEnabled;

  const isArcGisJsSDKWebMapForBrowsingCalculationResultsEnabled =
    useAppState().featureToggles?.isArcGisJsSDKWebMapForBrowsingCalculationResultsEnabled;
  const shouldUseInitiatingObjectHighlighting = useAppState().featureToggles?.shouldUseInitiatingObjectHighlighting;
  return {
    isEsriWebmapEnabled: () =>
      isUnleashConfigAvailable(appConfig) && Boolean(isEsriLeafletEnabled),
    isShowingGridElementTitleEnabled: () =>
      isUnleashConfigAvailable(appConfig) &&
      Boolean(isShowingGridDetailsEnabled),
    isShowingApplicationVersionEnabled: () =>
      isUnleashConfigAvailable(appConfig) &&
      Boolean(isShowingApplicationVersionEnabled) &&
      Boolean(isShowingApplicationVersionEnabled),
    isContainmentExecutionTimeCalculatedEnabled: () =>
      isUnleashConfigAvailable(appConfig) &&
      Boolean(isContainmentExecutionTimeCalculatedEnabled),
    isNewAuthVersionEnabled: () =>
      isUnleashConfigAvailable(appConfig) && Boolean(isNewAuthVersionEnabled),
    isProtectiveDevicesEnabled: () =>
      isUnleashConfigAvailable(appConfig) &&
      Boolean(isProtectiveDevicesEnabled),
    isWebmapBackgroundMapEnabled: () =>
      isUnleashConfigAvailable(appConfig) &&
      Boolean(isWebmapBackgroundMapEnabled),
    isNewPropertiesForAcLineSegmentEnabled: () =>
      isUnleashConfigAvailable(appConfig) &&
      Boolean(isNewPropertiesForAcLineSegmentEnabled),
    isArcGisJsSDKWebMapForBrowsingCalculationResultsEnabled: () =>
      isUnleashConfigAvailable(appConfig) &&
      Boolean(isArcGisJsSDKWebMapForBrowsingCalculationResultsEnabled),
    shouldUseInitiatingObjectHighlighting: () =>
      isUnleashConfigAvailable(appConfig) &&
      Boolean(shouldUseInitiatingObjectHighlighting)
  };
};

function isUnleashConfigAvailable(
  appConfig:
    | { type: 'NOT_AVAILABLE' }
    | { type: 'AVAILABLE'; config: ApplicationConfiguration }
) {
  return appConfig.type === 'AVAILABLE' && Boolean(appConfig.config.unleash);
}

export default useFeatureToggles;
